import { useState, useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

const useGetAuthEvents = () => {
  const [eventsList, setEventsList] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const getAuthEventsList = useCallback(
    (page = 1, limit = 10, urlParams = {}) => {
      setIsLoading(true)

      API.request({
        ...API_ROUTER.events.getAuthEvents,
        urlParams,
        pathKeys: {
          page,
          limit,
        },
      })
        .then(res => {
          setEventsList(res)
        })
        .catch(err => {
          console.error('Get auth events error:', err)
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    []
  )

  return {
    eventsList,
    isLoading,
    getAuthEventsList,
  }
}

export default useGetAuthEvents
